import * as React from "react";
import { useBloomreachPageRoutes, CmsComponentSlot } from "@grandvisionhq/bloomreach";
import { Container } from "@grandvisionhq/elements";
import { useFeatureToggles } from "@grandvisionhq/state";
import { Hooks, StoreFinderSlotsProvider, StoresRoot, StoreSearchPage } from "@grandvisionhq/stores-v2";
import { monetate } from "@grandvisionhq/svc-monetate";
import { useTealiumEventProperties, useTrackPageView } from "@grandvisionhq/svc-tealium/events";
import { isNumber } from "@grandvisionhq/utils";
import "@grandvisionhq/fun-store-filters/dist/index.css";
const Page = ({ storeSearchFilters, bookAppointmentUrl, stores } = {}) => {
  const { useDefaultStoreSearchFilters } = Hooks;
  const { routes } = useBloomreachPageRoutes();
  const defaultStoreSearchFilters = useDefaultStoreSearchFilters();
  const features = useFeatureToggles();
  const { commonEventProperties, getCommonUserProperties } = useTealiumEventProperties();
  const urls = React.useMemo(
    () => ({
      bookAppointment: bookAppointmentUrl ?? `${routes["appointment-book"]}/what`,
      storeDetails: routes.stores || ""
    }),
    [routes, bookAppointmentUrl]
  );
  const storeLocatorPageView = React.useCallback(async () => {
    const commonUserProperties = await getCommonUserProperties();
    if (!commonUserProperties) return;
    return {
      id: "VirtualPage-View",
      Page_Type: "StoreLocator",
      Page_Section1: "StoreLocator",
      ...commonEventProperties,
      ...commonUserProperties
    };
  }, [commonEventProperties, getCommonUserProperties]);
  useTrackPageView(storeLocatorPageView);
  const hidePhone = !features.isStoreSearchPhoneEnabled;
  const hideEmail = !features.isStoreSearchEmailEnabled;
  React.useEffect(() => {
    monetate().commitMonetateEvent("other_page");
  }, []);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/top-container" }), /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
    StoreFinderSlotsProvider,
    {
      slots: {
        SideComponents: () => /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/side-container" })
      }
    },
    /* @__PURE__ */ React.createElement(
      StoresRoot,
      {
        urls,
        googleMapsId: "google-maps-container",
        hidePhone,
        hideEmail,
        storeSearchFilters: storeSearchFilters ?? defaultStoreSearchFilters,
        stores
      }
    )
  )), /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/bottom-container" }));
};
Page.getInitialProps = async (ctx) => {
  const { req, apolloClient, pathname, query, featureToggles } = ctx;
  const locale = req?.locale?.toString();
  if (!apolloClient) {
    console.error(`ApolloClient not present in context for page ${pathname}`);
    return {};
  }
  if (!locale || !query?.lat || !query?.lon) {
    return {};
  }
  try {
    const {
      featureConfigs: { maxSearchStoresResults }
    } = featureToggles;
    const data = await StoreSearchPage.getStores(apolloClient, {
      coordinates: {
        lat: query.lat.toString(),
        lon: query.lon.toString()
      },
      locale,
      maxResults: maxSearchStoresResults
    });
    if (!data) {
      throw "No data";
    }
    const z = query.z && Number(+query.z);
    const hasLatLon = query.lat && query.lon;
    const zoomLevel = isNumber(z) && hasLatLon ? z : void 0;
    return {
      stores: data,
      zoomLevel: zoomLevel && zoomLevel <= 16 ? zoomLevel : void 0
    };
  } catch (e) {
    console.log(`Something went wrong fetching the initial stores on the stores page: ${e}`);
    return {};
  }
};
export {
  Page
};
//# sourceMappingURL=stores.js.map
